import { render, staticRenderFns } from "./PFormGroupRow.vue?vue&type=template&id=7bd0ab50&scoped=true&"
import script from "./PFormGroupRow.vue?vue&type=script&lang=ts&"
export * from "./PFormGroupRow.vue?vue&type=script&lang=ts&"
import style0 from "./PFormGroupRow.vue?vue&type=style&index=0&id=7bd0ab50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd0ab50",
  null
  
)

export default component.exports